import { render, staticRenderFns } from "./huiludet.vue?vue&type=template&id=13bbdf1a&scoped=true&"
import script from "./huiludet.vue?vue&type=script&lang=js&"
export * from "./huiludet.vue?vue&type=script&lang=js&"
import style0 from "./huiludet.vue?vue&type=style&index=0&id=13bbdf1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bbdf1a",
  null
  
)

export default component.exports